import React from 'react';
import { useTranslation } from 'react-i18next';
import ComparePage from './ComparePage';

const BANKS = [
  {
    name: 'RBC',
    cardName: 'RBC Cash Back Mastercard',
    cardData: {
      bank: 'RBC',
      annual_fee: 'No annual fee',
      newcomer_friendly: true,
      rewards: '0.5% cash back on all purchases, up to 1% on groceries',
    },
  },
  {
    name: 'TD',
    cardName: 'TD Cash Back Visa',
    cardData: {
      bank: 'TD',
      annual_fee: 'No annual fee',
      newcomer_friendly: true,
      rewards: '1% cash back on gas and groceries, 0.5% on all other purchases',
    },
  },
];

const ROWS = [
  { label: 'Cuota anual', values: ['Sin cuota', 'Sin cuota'] },
  { label: 'Cash back', values: ['Hasta 1% en supermercados', 'Hasta 1% en gasolina y supermercados'] },
  { label: 'Programa newcomer', values: ['Si - RBC Newcomer Package', 'Si - TD New to Canada'] },
  { label: 'App movil', values: ['RBC Mobile - 4.0/5', 'TD MySpend - 4.0/5'] },
  { label: 'Soporte en espanol', values: ['Parcial (sucursales selectas)', 'Si (linea telefonica + sucursales)'] },
  { label: 'Red de sucursales', values: ['Amplia en todo Canada', 'Amplia en todo Canada'] },
  { label: 'Seguro de viaje', values: ['No incluido', 'No incluido'] },
  { label: 'Tarjeta secured', values: ['Disponible', 'Disponible'] },
];

const FAQS = [
  {
    question: '¿Cuál es mejor para un recien llegado, RBC o TD?',
    answer: 'Ambos tienen excelentes programas para recien llegados. TD tiene una ligera ventaja en soporte en espanol con linea telefonica dedicada. RBC ofrece un paquete bancario newcomer muy completo con chequera gratuita el primer año.',
  },
  {
    question: 'Necesito historial crediticio canadiense para estas tarjetas?',
    answer: 'No. Tanto la RBC Cash Back Mastercard como la TD Cash Back Visa estan disponibles a traves de sus programas newcomer sin necesidad de historial crediticio canadiense. Solo necesitas tu documento de residencia o permiso de trabajo.',
  },
  {
    question: 'Puedo obtener ambas tarjetas al mismo tiempo?',
    answer: 'Tecnicamente si, pero no es recomendable al inicio. Cada solicitud genera un hard inquiry en tu credit report. Es mejor empezar con una tarjeta, usarla bien por 6 meses, y luego considerar una segunda.',
  },
];

const RELATED = [
  { to: '/comparar/scotiabank-vs-bmo-inmigrantes', label: 'Scotiabank vs BMO para inmigrantes' },
  { to: '/comparar/rbc-vs-desjardins-quebec', label: 'RBC vs Desjardins en Quebec' },
  { to: '/comparar/mejores-bancos-recien-llegados-canada-2026', label: 'Mejores bancos para recien llegados 2026' },
];

const RbcVsTdPage = () => {
  const { i18n } = useTranslation();
  return (
  <ComparePage
    seoTitle="RBC vs TD para recien llegados en Canada 2026"
    seoDescription="Comparacion detallada entre RBC y TD para recién llegados a Canada. Cash back, programas newcomer, soporte en espanol y FinMaple Score."
    seoKey="compararRbcTd"
    noIndex={i18n.language !== 'es'}
    canonical="/comparar/rbc-vs-td-recien-llegados"
    routeKey="compararRbcTd"
    breadcrumbLabel="RBC vs TD"
    atomicAnswer="Para recien llegados a Canada en 2026, tanto RBC como TD ofrecen tarjetas sin cuota anual con programas newcomer. TD tiene mejor soporte en espanol; RBC ofrece un paquete bancario mas completo para el primer año."
    banks={BANKS}
    comparisonRows={ROWS}
    veredicto="TD gana por un margen estrecho gracias a su soporte en espanol mas robusto y su programa New to Canada que incluye beneficios adicionales como transferencias internacionales. Sin embargo, si tu prioridad es un paquete bancario completo con chequera gratuita, RBC es excelente opcion. Ambos bancos te permitiran construir historial crediticio desde cero."
    faqs={FAQS}
    mayaText="No sabes cual elegir entre RBC y TD? Preguntale a Maya - te ayuda a decidir según tu situacion."
    relatedLinks={RELATED}
  />
  );
};

export default RbcVsTdPage;
